module.exports = __webpack_public_path__ + "static/media/coinbase.0687505f.svg";